import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import ValuesSection from './components/ValuesSection';
import MissionSection from './components/MissionSection';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <AboutHero />
      <MissionSection />
      <ValuesSection />
      <Footer />
    </div>
  );
};

export default AboutPage;
